export default {
  menu:{
    home: "Anasayfa",
    departments: "Departmanlar",
    therapists: "Ekibimize Katılın",
    services: "Servisler",
    contact: "İletişim"
  },
  home: {
    hero: {
      items: [
        {
          title: "Bir nefes al",
          image: require("@/assets/images/bg/11.jpg"),
          subtitle:
            "Gerçek zihinsel değişim, aynı döngülerde kaybolmayı bıraktığınızda başlar. Merkezimizde, bireylerin olumsuz ve işlevsiz düşüncelerini fark edip değiştirerek duygularını ve davranışlarını olumlu yönde dönüştürmelerine destek oluyoruz.",
        },
        {
          title: "Danışmanlık ile şekillenen dönüşüm",
          image: require("@/assets/images/bg/02.jpg"),
          subtitle:
            "Nefes’te sadece dinlemiyoruz. Alıştığınız inançların ötesine geçip, yaşamınızın asıl kaynağını yeniden keşfetmenizi sağlayarak, size yeni ve sınırsız yaşam potansiyellerine ulaşmanız için rehberlik eden bir danışmanlık sunuyoruz. İçinizdeki gücü keşfedin.",
        },
        {
          title: "Haftalar içinde dönüşümünüzü fark edin",
          image: require("@/assets/images/bg/01.jpg"),
          subtitle:
            "Zaman tanımlı ve yapılandırılmış danışmanlık ile derin bir içsel dönüşüm yaşayın. Kalıcı değişimler edinerek hayatınızı dönüştürün. İşlevsiz sohbetlere son vermeye ne dersiniz?",
        },
        {
          title: "Amacımız sizin gelişiminizdir",
          image: require("@/assets/images/bg/05.jpg"),
          subtitle:
            "Seanslar boyunca sizinle iletişimde olacağız. Psikolojik danışmanlarımızın, gereksinimlerinize özgü tasarladıkları çalışmaları pratik ederek hayatınıza doğal bir akışla entegre etmenize destek verecek. Çünkü bizim için geçici rahatlamanız değil, kalıcı dönüşümünüz önemli.",
        },
      ],
      button: "Uzmanla Konuş",
    },
    services: {
      title: "<span class='text-primary'>Sizin</span> için neler yapabiliriz?",
      items: [
        {
          icon: "RiOpenArmLine",
          title: "Kalıcı yöntem",
          desc: "Kalıcılık, sağlıklı ve bilinçli bir şekilde problem çözmeyi öğrenerek uygulamanızla gerçekleşir.",
        },
        {
          icon: "RiPsychotherapyLine",
          title: "Kişisel Danışmanlık",
          desc: "Danışmanlık süreci, duygusal, düşünsel ve davranışsal ihtiyaçlarınıza özel olarak şekillenecek ve tamamen size özgü bir yolculuk sunacaktır.",
        },
        {
          icon: "RiUserSmileLine",
          title: "Depresyon Desteği",
          desc: "En güncel yöntemlerimizle, umutsuzluk döngünüzden özgürleşmenizi ve duygusal dönüşümünüzü teşvik ediyoruz.",
        },
        {
          icon: "RiBrain2Line",
          title: "Stres Kontrolü",
          desc: "En güncel yöntemlerle, stres, kaygı ve korkunuzu özel yöntemlerle denetim altına alın.",
        },
        {
          icon: "RiPulseAiLine",
          title: "yineleyici ve zorlayıcı süreçlerin kontrolü",
          desc: "En güncel yöntemlerle, yineleyici ve zorlayıcı durumlarla başa çıkma stratejileri kazanarak yaşam kalitenizi artırın.",
        },
        {
          icon: "RiZzzLine",
          title: "Daha İyi Uyku",
          desc: "Uyku problemlerinin kökenini anlayarak sağlıklı bir uykuya kavuşun.",
        },
        /*{
          title: "Danışmanlık Eğitimi ",
          desc: Nefes tarafından özelleştirilmiş bilişsel ve davranışsal yöntemler eğitimi ile hem teorik bilginizi güçlendirin, hem de pratik deneyim kazanın.
        {
          title: "Online Danışmanlık ",
          desc: "Psikolojik danışmanlığı her zaman, her yerde; tamamen online ve güvenli bir şekilde alın."
        },*/
      ],
    },
    counter: [
      {
        icon: "client",
        title: "Desteklenen Danışan",
        desc: "Gerçek insanlar, gerçek değişim.",
        value: 7500,
      },
      {
        icon: "session",
        title: "Yapılan Seans",
        desc: "Sürekli destek, gerçek sonuçlar.",
        value: 67000,
      },
      {
        icon: "therapist",
        title: "Eğitilmiş Danışman",
        desc: "Özel yöntemimizle eğitilmiş danışmanlar.",
        value: 1500,
      },
      {
        icon: "avg",
        title: "Ortalama Seans",
        desc: "Ölçülebilir iyileşme için.",
        value: 9,
      },
    ],
    whyUs: {
      title: "Neden <span class='text-primary'>Nefes</span>?",
      subtitle: `Nefes'te size sadece bir danışmanın seans desteğini sunmuyoruz - işe yarayan bir sistem sunuyoruz. Tüm danışmanlarımız, en güncel bilişsel ve davranışsal yöntemlerle Nefes tarafından özel olarak eğitilmiştir.<br>
                Bu geleneksel bir danışmanlık değil. Sadece dinlemiyoruz. Zihinsel yapınızı yeniden şekillendirmek için yapılandırılmış, kişiselleştirilmiş en güncel bilişsel ve davranışsal yöntemler ve buna eşlik eden etkili egzersizler kullanıyoruz.
                Seanslarımız sürecin sadece bir parçası. Seanslar arasında da sizinle iletişimde kalıyor, gelişiminizi takip ediyor ve haftalık olarak sizi yönlendiriyoruz.
                <br>
                Nefes ile sadece iyi hissetmezsiniz - dönüşürsünüz.
      "Bu sadece danışmanlık değil. Bu, gerçekten sonuç veren bir yöntemdir."`,
      items: [
        {
          icon: "method",
          title: "Yöntem Temelli",
          description:
            "Yapılandırılmış, köklü ve en güncel bilişsel ve davranışsal yöntemlere dayanan yaklaşımımız, geçici rahatlamaların ötesine geçer, gerçek değişim sağlar.",
        },
        {
          icon: "training",
          title: "Nefes Eğitimi",
          description:
            "Tüm danışmanlarımız, Nefes tarafından modern ve bilimsel yöntemlerle özel olarak eğitilmiştir.",
        },
        {
          icon: "active",
          title: "Aktif Süreç",
          description:
            "Seanslar, düşünce kalıplarını dönüştürmek için özel egzersizler ve bilinçli uygulamalar içerir.",
        },
        {
          icon: "followup",
          title: "Haftalık Danışmanlık Takibi",
          description:
            "Seanslar dışında da sürecinizi takip ediyor, gerektiğinde yönlendirme sağlıyoruz.",
        },
      ],
    },
    cta: {
      title: "Hayatınızı değiştirmeye hazır mısınız?",
      subtitle:
        "Kanıtlanmış yöntemimizle bizimle yolculuğunuza bugün başlayın.",
      button: "Bir Danışmanla Görüşün",
      whatsappMessage: "Merhaba, danışmanlık seansı almak istiyorum.",
    },
    testimonials: {
      title: "Kullanıcı Deneyimleri",
      subtitle:
        "Her bireyin bir hikayesi vardır. Nefes'te binlerce kişinin hikâyesini yeniden yazmasına yardımcı olduk. Yöntemimiz, danışanlarımızın aktarımlarına dayanarak seansları özenle yapılandırır. İşte danışmanlık seanslarına başladıktan kısa süre sonra danışanlarımızın söyledikleri.",
      list: [
        {
          name: "Defne, 35",
          department: "Depresyon",
          text: "Nefes’i tanıdığımda artık umudum kalmamıştı. Sadece hayatta kalıyor fakat yaşamıyordum. Yapılandırılmış yöntemleri sayesinde tekrar kendimi hissetmeye başladım. Şimdi gerçekten yaşıyorum.",
        },
        {
          name: "Serkan, 31",
          department: "kaygı",
          text: "Kaygı hayatımı ele geçirmişti. Nefes seansları ile birlikte iç huzuruma kavuştum.",
        },
        {
          name: "Yağmur, 27",
          department: "Uyku Sorunları",
          text: "Aylarca doğru düzgün uyuyamadım. Nefes'teki danışmanlık seansları, uyku sorunumun temelini ortaya çıkardı. Artık huzurla uyuyorum.",
        },
        {
          name: "Ela, 29",
          department: " OKB",
          text: "Zihnimi takıntılı düşünceler ele geçirmişti., Nefes'ten aldığım danışmanlık sayesinde zihinsel özgürlüğümü kazandım.",
        },
        {
          name: "Hakan, 27",
          department: "Stres",
          text: "İş stresi beni mahvediyordu. Baskı sadece dışarıdan değil, içeriden de geliyormuş; seanslarımda öğrendim…Şimdi yeniden kontrol bende.",
        },
        {
          name: "Özgür, 34",
          department: "Panik Atak",
          text: "Panik atağın ne olduğunu yaşamayan bilemez. Nefes bana yeniden “nefes almayı” öğretti. Artık atak geldiğinde nasıl baş edeceğimi biliyorum.",
        },
        {
          name: "Seher, 38",
          department: "Gizli Depresyon",
          text: "Dışarıdan gülümsüyordum ama içim boştu. Nefes sayesinde artık rol yapmıyorum. Gerçekten iyileşiyorum.",
        },
        {
          name: "Deniz, 25",
          department: "Özgüven Eksikliği",
          text: "Eskiden hep sessizdim. Nefes bana sesimi bulmayı öğretti. Artık konuşuyorum ve insanlar dinliyor.",
        },
        {
          name: "Furkan, 45",
          department: "Kronik Uykusuzluk",
          text: "Daha önce uyku sorunumla ilgili pek çok yöntem denemiştim. Ama Nefes'teki danışmanlık, sorunun derinine indi. Şimdi doğal olarak uyuyorum bu sayede günü çok daha enerjik yaşayabiliyorum.",
        },
        {
          name: "Umut, 28",
          department: "Amaçsızlık",
          text: "Ne istediğimi bilmiyordum. Ama Nefes sayesinde içimdeki bilinmeyen parçaları keşfettim. Artık sadece var olmuyorum, yaşıyorum.",
        },
      ],
    },
  },
  faq: {
    title: "Sıkça Sorulan Sorular",
    subtitle:
      "Hizmetlerimiz, yöntemimiz ve danışmanlarımız hakkında en çok sorulan soruları burada yanıtlıyoruz.",
    items: [
      {
        question: "Nefes’i diğer danışmanlık merkezlerinden ayıran nedir?",
        answer:
          "Nefes, tüm danışmanlarını kendi özel yöntemiyle eğitir. Sadece bir danışman atamıyoruz; yapılandırılmış bir sistem sunuyoruz ve seanslar arası süreci aktif olarak takip ediyoruz.",
      },
      {
        question:
          "Sizden psikolojik danışmanlık aldığımda gerçekten faydasını görebilir miyim? Ne kadar zamanda fayda alırım?",
        answer:
          "Evet. Yöntemimiz kısa sürede gözle görülür değişim alacağınız bir süreçtir.  Çoğu danışanımız ilk bir kaç seansta önemli bir gelişme kaydeder.",
      },
      {
        question: "Danışmanlarınız lisanslı mı?",
        answer:
          "Kesinlikle. Nefes psikolojik danışmanlarının hepsi lisanslı profesyonellerdir ve ayrıca kurumumuzca özel olarak eğitilerek en güncel bilişsel ve davranışsal yöntemlerin danışmanlık uygulamalarında uzmanlaşmışlardır. Hem profesyonel hem de felsefi olarak Nefes ile uyumludurlar.",
      },
      {
        question: "Hangi psikolojik sorunları ele alıyorsunuz?",
        answer:
          "Depresyon, kaygı, OKB ve uyku sorunlarını ele alıyoruz. Yeme bozukluğu, bipolar bozukluk ve  kanser psikolojisi açılacak diğer departmanlarımız arasında. Yöntemimiz esnektir ve birçok psikolojik zorluğa destek vermek üzere uyarlanabilir.",
      },
      {
        question: "seanslar online mı yoksa yüz yüze mi?",
        answer:
          "Tüm danışmanlık seanslarımız online olarak yürütülür. Bu, yoğun programı olan ya da bulunduğu bölgede kaliteli danışmanlığa erişimi olmayan bireyler için büyük avantaj sağlar.",
      },
      {
        question: "Her seans ne kadar sürer?",
        answer: "Bir seans genellikle 45 ila 50 dakika sürer.",
      },
      {
        question: "Kaç seans gereklidir?",
        answer:
          "Çoğu danışanımız birkaç seans içinde büyük ilerleme gösterir. Ancak gerekli seans sayısı kişisel durumunuza göre değişebilir. Sizin için özel olarak yapılandırılır.",
      },
      {
        question: "Psikolojik danışmanımı nasıl seçebilirim?",
        answer:
          "Danışmanınızı, ihtiyaçlarınız ve danışmanlık almanız gereken yöntemi dikkate alarak sizin için en etkin sonucu elde edecek şekilde biz belirliyoruz.",
      },
      {
        question: "İlk seansı nasıl ayarlayabilirim?",
        answer:
          "Web sitemiz veya WhatsApp üzerinden bizimle iletişime geçebilirsiniz. Size ücretsiz bir ön görüşme sunulacaktır.",
      },
      {
        question: "İlk görüşme gerçekten ücretsiz mi?",
        answer:
          "Evet. İlk danışmanlık tamamen ücretsizdir ve herhangi bir yükümlülük içermez. Amacımız yöntemi tanımanıza yardımcı olmaktır.",
      },
      {
        question: "İlaç reçete ediyor musunuz?",
        answer:
          "Hayır. İlaç reçetesi verilmez; yöntemimiz zihinsel yeniden yapılanmaya dayanır.",
      },
      {
        question: "Anonim olarak danışmanlık alabilir miyim?",
        answer:
          "Evet. İsterseniz anonim olarak seansa katılabilirsiniz. Bilgileriniz %100 gizli tutulur.",
      },
      {
        question: "Seanslar hangi dilde gerçekleşiyor?",
        answer:
          "Seanslar Türkçe, Farsça ve İngilizce dillerinde yapılabilir. Tercihinize göre dil seçebilirsiniz.",
      },
      {
        question: "Bu yöntemin bana uygun olup olmadığını nasıl anlarım?",
        answer:
          "Ücretsiz ön görüşme sırasında ihtiyaçlarınız değerlendirilir ve nasıl yardımcı olabileceğimiz açıklanır.",
      },
      {
        question:
          "Resmi bir tanı almamış olsam da yine de sizden danışmanlık alabilir miyim?",
        answer:
          "Kesinlikle. Birçok danışanımız resmi bir tanıya sahip değildir ama yine de büyük fayda sağlar.",
      },
      {
        question: "İş stresi veya tükenmişlik konusunda yardımcı olur musunuz?",
        answer:
          "Evet. İş stresi, tükenmişlik ve duygusal yorgunluk en sık çalıştığımız konulardandır.",
      },
      {
        question: "Birkaç seanstan sonra ilerleme görmezsem ne olur?",
        answer:
          "Geri bildiriminiz bizim için önemlidir. Gerekirse dosyanız yeniden değerlendirilir, danışman değiştirilebilir.",
      },
      {
        question: "Karar vermeden önce biriyle konuşabilir miyim?",
        answer:
          "Elbette. 'Danışmanla Görüş' butonuna tıklayarak ücretsiz ve yükümlülüksüz bir görüşme başlatabilirsiniz.",
      },
      {
        question: "Danışmanlık çocuklar veya gençler için uygun mu?",
        answer:
          "Şu anda Nefes, yalnızca 18 yaş ve üzeri bireylerle çalışmaktadır.",
      },
      {
        question: "Bilgilerim gizli tutulacak mı?",
        answer:
          "Evet. Tüm bilgileriniz en yüksek gizlilik standartlarında saklanır ve asla izniniz olmadan paylaşılmaz.",
      },
      {
        question: "Bilgilerime kimler erişebilir?",
        answer:
          "Yalnızca sürecinizde yer alan lisanslı danışmanlar verilerinize erişebilir ve bu veriler yalnızca danışmanlık amacıyla kullanılır.",
      },
      {
        question: "Danışmanlık sürecim izleniyor mu?",
        answer:
          "Evet. Danışmanlık süreciniz sistem tarafından sürekli izlenir.",
      },
      {
        question: "Danışmanlık tamamlandıktan sonra takip ediliyor muyum?",
        answer:
          "Evet. Danışmanlık sonrası belli aralıklarla sizinle iletişime geçerek sürecin kalıcılığı sağlanır.",
      },
      {
        question: "Nefes danışmanı nasıl olabilirim?",
        answer:
          "Web sitemizden başvurabilirsiniz. Kabul edildiğinizde özel eğitim programımıza dahil olursunuz.",
      },
      {
        question: "Yeni danışmanlardan ne tür nitelikler bekliyorsunuz?",
        answer:
          "Psikolog ve klinik psikologlar ile çalışıyoruz. Bizim eğitimimizi alarak bütüncül olarak danışanlarımıza sunabilmelerini bekliyoruz.",
      },
      {
        question: "Uluslararası danışmanlarla çalışıyor musunuz?",
        answer:
          "Evet. Türkçe, Farsça veya İngilizce bilen dünya çapındaki profesyonelleri memnuniyetle kabul ediyoruz.",
      },
    ],
  },
  footer: {
    tagline:
      "Nafas is more than therapy — it's a method, a mindset, and a commitment to lasting transformation. Our therapists are trained in a unique psychoanalytic approach that tracks your progress every step of the way.",
  },
  departments: {
    title: "Uzmanlık Alanlarımız",
    subtitle: "Nefes’in danışmanları hangi konularda size yardımcı olabilir?",
    more: "Daha Fazla",
    items: [
      {
        icon: "depression",
        title: "depresyon",
        desc: "Depresyonla başa çıkmayı öğrenin ve hayatınıza dengeyi geri kazandırın. Yöntemimiz, olumsuz düşünce kalıplarınızı fark etmenize yardımcı olur ve zorlayıcı zamanlarda bile kendinizi yeniden toparlamanızı sağlar.",
      },
      {
        icon: "anxiety",
        title: "Kaygı ve korku",
        desc: "Kaygı ve korkunuzla başa çıkmayı öğrenin, zihinsel huzurunuzu yeniden keşfedin. Yöntemimiz, kaygınızı yönetmenize ve sağlıklı düşünce alışkanlıkları geliştirmenize yardımcı olur.",
      },
      {
        icon: "ocd",
        title: "Takıntılar",
        desc: "Takıntılı düşünceler ve zorlayıcı davranışlarla başa çıkmayı keşfedin. Danışmanlarımız, OKB döngülerini kırmak ve zihinsel rahatlama sağlamak için size etkili teknikler sunar.",
      },
      {
        icon: "sleep",
        title: "Uyku Bozuklukları",
        desc: "Uykusuzluk ve düzensiz uyku alışkanlıklarıyla başa çıkmanın yollarını öğrenin. Danışmanlarımız, sağlıklı uyku düzeni oluşturmanız ve dinlendirici bir uyku için etkili yöntemleri sizinle paylaşır.",
      },
    ],
  },
  departmentsContent: {
    depression: {
      title: "Depresyon",
      subtitle: "Hayat anlamsız geldiğinde, iyileşme içten başlar...",
      description:
        "Depresyon, duygular, enerji seviyesi, motivasyon ve fiziksel sağlık gibi yaşamın birçok yönünü etkileyebilen en yaygın ve karmaşık ruhsal bozukluklardan biridir. Bu bölümde depresyonun köklerine iniyor ve size özgü yapılandırılmış danışmanlıkla içsel bir yeniden inşa sürecine yönlendiriyoruz.",
      symptoms: [
        "Sürekli yorgunluk ve motivasyon eksikliği",
        "Eskiden keyif alınan şeylere karşı ilgisizlik",
        "Suçluluk veya değersizlik duyguları",
        "Konsantrasyon veya hafıza sorunları",
        "Uyku veya iştah bozuklukları",
        "Boşluk hissi, sebepsiz ağlama, tekrarlayan olumsuz düşünceler",
        "intihar düşünceleri veya planları",
        "Karar verme zorluğu",
      ],
      method:
        "Nefes’te, davranışsal analiz ile seanslar arası egzersizleri bütüncül bir yaklaşımla birleştirdiğimiz bilişsel ve davranışsal metodlar kullanarak bir danışmanlık süreci uyguluyoruz. Bu yöntem, düşünce ve davranış kalıplarınızı yeniden yapılandırmanıza, içsel motivasyonunuzu güçlendirmenize ve sürdürülebilir, anlamlı bir değişime erişmenize olanak tanır.",
    },
    /*stress: {
      title: "Stres",
      subtitle: "Kronik gerilim günlük yaşamın bir parçası olmamalı...",
      description:
        "Stres modern yaşamın bir parçasıdır; ancak yönetilemeyen stres, kararlarımızı, ilişkilerimizi ve sağlığımızı bozabilir. Bu bölümde, gizli stres tetikleyicilerini tespit ediyor, tepki mekanizmalarını yeniden inşa ediyor ve etkili başa çıkma stratejileri öğretiyoruz.",
      symptoms: [
        "Sürekli baskı hissi ve gevşeyememe",
        "Sinirlilik veya sürekli öfke",
        "Zihinsel huzursuzluk veya odaklanma zorluğu",
        "Açıklanamayan fiziksel rahatsızlıklar (baş ağrısı, mide ağrısı vb.)",
        "Sosyal etkileşimlerden sonra aşırı yorgunluk",
      ],
      method:
        "Bilişsel kalıpları analiz ediyor, psikolojik tetikleyicileri belirliyor ve yüksek baskılı durumları yönetmek için pratik araçlar sunuyoruz. Terapi süreci, düzenli takiplerle desteklenir.",
    },*/
    anxiety: {
      title: "Kaygı ve Korku",
      subtitle: "Zihin kontrolünü kaybettiğinde, beden de zarar görür...",
      description:
        "Kaygı ve korku çoğu zaman birlikte ortaya çıkar ve zihinsel, fiziksel ve sosyal sağlığı ciddi şekilde etkileyebilir. Bu bölümde, bu duyguların kökenlerini belirliyor ve yüzeysel baskılamanın ötesinde yeniden yapılandırma sağlıyoruz.",
      symptoms: [
        "Sürekli endişe ve felaket senaryoları düşünmek",
        "Fiziksel gerginlik, kalp çarpıntısı, nefes darlığı",
        "Huzursuzluk ve mantıksız korkular",
        "Sosyal veya mesleki sorumluluklardan kaçınma",
      ],
      method:
        "Nefes’te, kaygı ile başa çıkmanız için bilişsel ve davranışsal metodları kullanıyoruz. Davranışsal analiz ve seanslar arası egzersizleri birleştirerek kaygının kökenini anlamanıza, düşünce kalıplarınızı dönüştürmenize ve kaygı döngüsünden çıkıp iç huzurunuzu yeniden keşfetmenize yardımcı oluyoruz.",
    },
    ocd: {
      title: "OKB",
      subtitle: "Bırakamayan bir zihin nazikçe yönlendirilmelidir...",
      description:
        "OKB, alışkanlık ya da düzen takıntısından öte; tekrarlayan, müdahaleci düşünceler ve zorlayıcı davranışlardan oluşur. Amacımız sadece belirtileri hafifletmek değil, bu döngülerin temelini değiştirmektir.",
      symptoms: [
        "Tekrarlayan, müdahaleci düşünceler",
        "Belirli davranışlar yapılmadığında yoğun kaygı hissi",
        "Korkuyu azaltmak için yapılan ritüelistik davranışlar",
        "Davranışların mantıksız olduğunun farkında olmak ama durduramamak",
      ],
      method:
        "Nefes’te, OKB ile etkin bir şekilde başa çıkmak için bilişsel ve davranışsal yaklaşımları benimsiyoruz. Böylelikle, takıntılı düşünceleri ve zorlayıcı davranışları anlamanızı ve yönetmenizi sağlıyoruz. Seanslar arası egzersizlerle, zihinsel esnekliğinizi artırıp, özgürleşmenize yardımcı olarak günlük yaşamınızı daha huzurlu bir şekilde sürdürmenizi destekliyoruz.",
    },
    sleep: {
      title: "Uyku Bozuklukları",
      subtitle: "Yorgun bir beden yalnızca daha fazla hata üretir...",
      description:
        "Uyku problemleri genellikle çözülmemiş zihinsel stres ve içsel huzursuzluğun sonucudur. Bu bölümde, uyku bozukluklarının psikolojik ve davranışsal nedenlerini analiz ediyor, derin ve dinlendirici bir uykuya dönüşü hedefliyoruz.",
      symptoms: [
        "Kronik uykusuzluk veya uykuya dalamama",
        "Gece boyunca sık sık uyanma veya hafif, huzursuz uyku",
        "Saatlerce uyunsa bile yorgun hissetmek",
        "Uykuya dalmayı engelleyen sürekli düşünceler",
      ],
      method:
        "Nefes’te, uykusuzlukla başa çıkmak için bilişsel ve davranışsal metodları bilinçli yapılandırılmış bir içerikle uyguluyoruz. Bu yaklaşım sayesinde, müdahaleci düşünceleri yatıştırmanızı, uykuya geçişi kolaylaştırmanızı ve doğal uyku ritminizi yeniden kurmanızı sağlıyoruz. Seanslar arası egzersizlerle, uyku alışkanlıklarınızı geliştirip daha dinlendirici bir uyku için sizi destekliyoruz.",
    },
  },
  therapists: {
    title: "Danışman Ağına Katılın",
    description:
      "<span style='font-weight:bolder;font-size:24px;'>Nefes’te</span> danışman olarak nasıl çalışabileceğinizi ve eğitim sürecimizi öğrenin.",
    howWeWork: {
      title: "Danışmanlarla Nasıl Çalışıyoruz?",
      subtitle:
        "Nefes olarak, danışmanlarımızın değerlerimizle uyumlu olmalarını bekliyoruz ve yöntemimizi tam olarak  benimsemelerini sağlayan yapılandırılmış bir süreç izliyoruz.",
      steps: [
        {
          title: "Başvuru",
          text: "Psikolojik  Danışmanlar, online başvuru formumuzu doldurarak Nefes ile iş birliği sürecine ilk adımı atarlar. Bu aşama, adayın geçmişi, deneyimi ve motivasyonuna dair temel bilgileri edinerek kendisini tanımamıza yardımcı olur.",
        },
        {
          title: "Bilgilendirme Oturumu",
          text: "Ön değerlendirme sonrası uygun bulunan danışmanlar, yöntemimizi ve beklentilerimizi tanıttığımız kısa bir çevrim içi bilgilendirme oturumuna davet edilirler. Bu oturum, karşılıklı sorular ve netleştirmeler için de bir fırsat sunar.",
        },
        {
          title:
            "Bilişsel Davranışsal Yöntemleri Temel Alan Danışmanlık Eğitimi",
          text: "Modelimize uygunluk gösteren danışmanlar, Nefes tarafından geliştirilmiş özel bir bilişsel ve davranışsal eğitimine katılır. Bu eğitim, hem teorik temeli hem de pratik uygulamayı kapsamaktadır.",
        },
        {
          title: "Sertifika ve İş Birliği",
          text: "Eğitimi başarıyla tamamlayan danışmanlar, sertifika alır ve resmi olarak Nefes danışman ağına dahil edilir. Bu aşamadan sonra, süpervizyon ve gelişim desteğiyle danışanlarla çalışmaya başlarlar.",
        },
      ],
    },
    "form0": {
      "title": "Kayıt Formu",
      "first_name": "Ad",
      "last_name": "Soyad",
      "birth_date": "Doğum Tarihi",
      "gender": "Cinsiyet",
      "male": "Erkek",
      "female": "Kadın",
      "marriage_status": "Medeni Durum",
      "single": "Bekar",
      "married": "Evli",
      "degree": "Mezuniyet Derecesi",
      "university": "Üniversite",
      "graduate_date": "Mezuniyet Tarihi",
      "experience": "Deneyim",
      "phone": "Telefon",
      "email": "E-posta",
      "email_code": "E-posta Doğrulama Kodu",
      "email_code_placeholder": "6 haneli kodu giriniz",
      "verify": "Doğrula",
      "verified": "Doğrulandı",
      "send_code": "Kod Gönder",
      "job_history": "İş Geçmişi",
      "city": "Şehir",
      "address": "Adres",
      "submit": "Kaydol",
      "completed": "Kayıt Tamamlandı",
      "agreement_label": "Sözleşme şartlarını okudum ve kabul ediyorum.",
      "agreement_accept": "Kabul Ediyorum",
      "back_home": "Ana Sayfaya Dön"
    },
    "validation": {
      "first_name_min": "İsim en az 2 karakter olmalıdır",
      "last_name_min": "Soyisim en az 2 karakter olmalıdır",
      "degree_required": "Mezuniyet derecesi gereklidir",
      "email_required": "Lütfen e-posta adresinizi girin ve doğrulayın",
      "city_required": "Şehir alanı gereklidir",
      "address_required": "Adres alanı gereklidir",
      "birthdate_required": "Doğum Tarihi alanı gereklidir alanı gereklidir",
      "email_invalid": "Geçerli bir e-posta adresi girin.",
      "agreement_required": "Sözleşme kabul etmeniz gerekiyor."
    },
    "messages": {
      "whatsapp_instruction": "Kayıt yönergesi için lütfen bu WhatsApp numarasına mesaj gönderin.",
      "registration_success": "Kayıt başarıyla tamamlandı.",
      "email_invalid": "Geçerli bir e-posta adresi girin.",
      "email_code_failed": "Kod gönderilemedi. Lütfen tekrar deneyin.",
      "verification_failed": "Doğrulama başarısız. Lütfen tekrar deneyin.",
      "send_whatsapp": "WhatsApp ile Mesaj Gönder"
    },
    form1: {
      title: "New Therapist Application",
      fullName: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      city: "City",
      specialization: "Specialization",
      experience: "Years of Experience",
      motivation: "Why do you want to work with Nafas?",
      submit: "Submit",
    },
    form2: {
      title: "Training Participation & Contract",
      fullName: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      trainingGroup: "Select Training Group",
      timeSlot: "Preferred Time Slot",
      consent: "I agree to the terms and training program.",
      signature: "Signature",
      signaturePlaceholder: "Type or draw your signature",
      submit: "Confirm and Join",
    },
  },
};
